import axiosInstance from './api';
import {
  EXTRACT_PARTNER_DETAILS_PROMPT_MAX,
  EXTRACT_PARTNER_DETAILS_TIMEOUT_MS,
  countFilledPartnerDescribeFields,
  mapExtractedPartnerDetailsToFormPatch,
} from '../components/PartnerSettings/PartnerSettingsSection/companyInfoDefaults';

const getApiErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  return (
    error.message ||
    error?.error?.message ||
    error?.data?.message ||
    error?.response?.data?.message ||
    fallback
  );
};

/**
 * POST /admin/extract-partner-details — JSON `{ prompt }`; returns Company Info copy fields.
 */
export const extractPartnerDetailsFromPrompt = async (prompt, { signal } = {}) => {
  const text = String(prompt ?? '').trim();
  if (!text) {
    return { success: false, message: 'Describe your community before generating.' };
  }

  if (text.length > EXTRACT_PARTNER_DETAILS_PROMPT_MAX) {
    return {
      success: false,
      message: `Prompt must be at most ${EXTRACT_PARTNER_DETAILS_PROMPT_MAX} characters.`,
    };
  }

  try {
    const response = await axiosInstance.post(
      '/admin/extract-partner-details',
      { prompt: text },
      { timeout: EXTRACT_PARTNER_DETAILS_TIMEOUT_MS, signal },
    );

    const payload = response.data;
    const data = payload?.data ?? payload;
    const formPatch = mapExtractedPartnerDetailsToFormPatch(data);

    if (countFilledPartnerDescribeFields(formPatch) === 0) {
      return {
        success: false,
        message: payload?.message || 'No partner details could be extracted from the prompt.',
      };
    }

    return {
      success: true,
      partnerDetails: data,
      formPatch,
      message: payload?.message || 'Partner details extracted successfully',
    };
  } catch (error) {
    return {
      success: false,
      message: getApiErrorMessage(error, 'Failed to extract partner details'),
      error,
    };
  }
};
